import { AntDatePickerWithDayjs } from '@common/general-ui/date-picker/ant-date-picker.component';
import { PickerTimeProps } from 'antd/es/date-picker/generatePicker';
import { Dayjs } from 'dayjs';
import React from 'react';

type IProps = Omit<PickerTimeProps<Dayjs>, 'picker'>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AntTimePickerWithDayjs = React.forwardRef<any, IProps>((props, ref) => {
    return <AntDatePickerWithDayjs {...props} picker="time" mode={undefined} ref={ref} />;
});
